import { instanciaAxios } from './base.service';

const pathBase = 'relatorio';

class RelatoriosService {
  gerarPontosGanhosPorIda() {
    return instanciaAxios.get(`${pathBase}/pontos_ganhos_ida`, { responseType: 'arraybuffer' });
  }

  gerarGeneros() {
    return instanciaAxios.get(`${pathBase}/generos`, { responseType: 'arraybuffer' });
  }

  gerarTrocas() {
    return instanciaAxios.get(`${pathBase}/trocas`, { responseType: 'arraybuffer' });
  }

  gerarQtdProdutoPorLoja() {
    return instanciaAxios.get(`${pathBase}/quantidade-produto-loja`, { responseType: 'arraybuffer' });
  }
}

export default new RelatoriosService();
